import {
  GET_TERMINAL_SUBJECT,
  GET_TERMINAL_SUBJECT_DETAILS,
} from "../constants/Type";

const initialState = {
  terminalSubject: null,
  selected_terminal_subject: null,
  loading: true,
};

const terminalSubjectReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_TERMINAL_SUBJECT:
      return {
        ...state,
        terminalSubject: payload,
        loading: false,
      };
    case GET_TERMINAL_SUBJECT_DETAILS:
      return {
        ...state,
        selected_terminal_subject: payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default terminalSubjectReducer;
